import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

export const loginUrl = (path) => `/login?redir=${encodeURIComponent(path)}`;

// Garde des pages de l'espace client : sans session (client.id vaut `false`
// par défaut, cf. reducers/client.jsx), renvoie vers la connexion en gardant
// la page demandée (chemin + query) dans `redir`, que Login.jsx suit après
// connexion. Réactive à client.id : une session invalidée en cours de route
// (unsetClient) renvoie aussi vers la connexion.
const useRequireLogin = () => {
  const clientId = useSelector((s) => s.client.id);
  const history = useHistory();

  useEffect(() => {
    if (!clientId) {
      const { pathname, search } = history.location;
      history.replace(loginUrl(`${pathname}${search}`));
    }
  }, [clientId]);

  return !!clientId;
};

export default useRequireLogin;
